import { useState, useEffect } from "react";
import { authedFetch } from "@/lib/auth";
import type { LiveStepDisplay } from "./live-walkthrough-screenshot";

export function useLiveScreenshot(
  walkthroughId: string,
  displayedStep?: LiveStepDisplay,
) {
  const [screenshotBlobUrl, setScreenshotBlobUrl] = useState<string | null>(
    null,
  );
  const [screenshotLoading, setScreenshotLoading] = useState(false);

  useEffect(() => {
    if (!displayedStep?.screenshotPath) {
      setScreenshotBlobUrl(null);
      return;
    }
    let cancelled = false;
    setScreenshotLoading(true);
    authedFetch(
      `/api/walkthroughs/${walkthroughId}/screenshots/${displayedStep.stepNumber}`,
    )
      .then((res) => (res.ok && !cancelled ? res.blob() : null))
      .then((blob) => {
        if (blob && !cancelled) setScreenshotBlobUrl(URL.createObjectURL(blob));
      })
      .catch(() => {})
      .finally(() => {
        if (!cancelled) setScreenshotLoading(false);
      });

    return () => {
      cancelled = true;
      setScreenshotBlobUrl((prev) => {
        if (prev) URL.revokeObjectURL(prev);
        return null;
      });
    };
  }, [walkthroughId, displayedStep?.stepNumber, displayedStep?.screenshotPath]);

  return { screenshotBlobUrl, screenshotLoading };
}
